import React from "react";
import { clockLabel } from "../../utils/consolidationPresentation.js";

/**
 * Heures prévues changées par le Dispatch (`describeGroup(...).times`) : avant, maintenant et heure saisie,
 * arrêt par arrêt. Le même tableau sert à Consolidation et à la carte de blocage de Facturation.
 */
export default function PlannedTimeChanges({ times, timezone }) {
  const several = new Set(times.map(time => time.source_key)).size > 1;
  // Largeur du contenu : les heures restent près de leur arrêt, même dans un panneau très large.
  return <table className="w-auto min-w-0 text-left tabular-nums">
    <thead><tr className="text-[10px] text-slate-500 [&>th]:static"><th className="py-0.5 pr-6 font-bold">Changement</th><th className="px-3 py-0.5 text-right font-bold">Avant</th>
      <th className="px-3 py-0.5 text-right font-bold">Maintenant</th><th className="py-0.5 pl-3 text-right font-bold">Heure saisie</th></tr></thead>
    <tbody>{times.map(time => <tr key={time.id} className="border-t border-slate-200">
      <td className="py-0.5 pr-6">{[time.label, time.stop, several ? time.route : ""].filter(Boolean).join(" · ")}</td>
      <td className="px-3 py-0.5 text-right text-slate-500 line-through">{clockLabel(time.before, timezone)}</td>
      <td className="px-3 py-0.5 text-right font-bold">{clockLabel(time.after, timezone)}</td>
      <td className="py-0.5 pl-3 text-right">{clockLabel(time.actual, timezone)}</td>
    </tr>)}</tbody>
  </table>;
}
